export default "<div class=\"dropdown-link-wrap\" (click)=\"toggleDropdown()\">\r\n  <ng-content></ng-content>\r\n</div>\r\n"